// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"menu_menuContainer__2bOkq","formContainer":"menu_formContainer__GP-0W","checkboxContainer":"menu_checkboxContainer__3fsiz"};